import { routes } from "instanceManagement/routes";
import { useTranslation } from "react-i18next";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import TranslateOutlinedIcon from "@mui/icons-material/TranslateOutlined";

import Sidebar from "features/layout/SidebarNav/Sidebar";
import { NavGroup } from "features/layout/SidebarNav/types";

import { RouteConfig } from "services/routesConfig";

interface Props {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
  toggleExpand: () => void;
  routeConfig: RouteConfig;
}

const SidebarNav = ({
  expanded,
  setExpanded,
  toggleExpand,
  routeConfig,
}: Props) => {
  const { t } = useTranslation();
  const navGroups: NavGroup[] = [
    {
      title: t("instance_management:tenants.title"),
      links: [
        {
          icon: HomeOutlinedIcon,
          text: t("instance_management:tenants.title"),
          to: routes.tenants,
          hasUnlistedSubroutes: true,
          testId: "nav-tenants",
        },
      ],
    },
    {
      title: t("common:menu.section.admin"),
      links: [
        {
          icon: TranslateOutlinedIcon,
          text: t("pages:localization.title"),
          to: routes.localization,
          testId: "nav-localization",
        },
      ],
    },
  ];

  return (
    <Sidebar
      navGroups={navGroups}
      expanded={expanded}
      setExpanded={setExpanded}
      toggleExpand={toggleExpand}
      routeConfig={routeConfig}
    />
  );
};

export default SidebarNav;
